import React, { useState, useEffect, useCallback, memo } from "react";
import { IconButton, CircularProgress, Typography, Box } from "@mui/material"; // Import Box and Typography
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { useLikes } from "../hooks/useLikes"; // Import your useLikes hook

const LikeButton = memo(function LikeButton({ userId, itemId }) {
  // Removed onLikeChange as useLikes handles internal state and count
  const { isLiked, likeCount, toggleLike, likeLoading, likeError } =
    useLikes(itemId); // Use the custom hook

  // This internal state is now managed by useLikes, so we can remove it from here
  // const [liked, setLiked] = useState(false);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  // The useEffect for initial like status and handleLikeToggle are now handled by useLikes.
  // You can remove them from this component.

  if (!userId || !itemId) {
    return null; // Don't render if required props are missing
  }

  const iconSize = 36; // You can adjust this value

  return (
    <IconButton
      onClick={toggleLike} // Use toggleLike from useLikes hook
      aria-label={isLiked ? "Unlike" : "Like"} // Use isLiked from useLikes hook
      disabled={likeLoading} // Use likeLoading from useLikes hook
      size="large"
      sx={{
        color: "red",
        borderRadius: "50%",
        position: "relative", // Needed for absolute positioning of the count
        "&:hover": {
          backgroundColor: "rgba(133, 23, 23, 0.1)",
        },
      }}
    >
      {likeLoading ? (
        <CircularProgress size={iconSize} color="error" />
      ) : isLiked ? (
        <Favorite sx={{ color: "red", fontSize: iconSize }} />
      ) : (
        <FavoriteBorder sx={{ color: "red", fontSize: iconSize }} />
      )}

      {/* Like Count Display */}
      {!likeLoading &&
        typeof likeCount === "number" && ( // Only show count when not loading and count is available
          <Box
            sx={{
              position: "absolute",
              top: 0, // Adjust this value to move the count higher/lower
              right: 0, // Adjust this value to move the count left/right
              backgroundColor: "rgba(0, 0, 0, 0.6)", // Semi-transparent dark background
              color: "white",
              borderRadius: "50%", // Make it round
              minWidth: "20px", // Minimum width for single digits
              height: "20px", // Height for the badge
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 4px", // Horizontal padding
              fontSize: "0.75rem", // Smaller font size
              fontWeight: "bold",
              lineHeight: 1, // Ensure text aligns vertically
              transform: "translate(25%, -25%)", // Nudge it outside the button slightly
              boxShadow: "0 0 3px rgba(0,0,0,0.3)", // Subtle shadow for depth
            }}
          >
            <Typography
              variant="caption"
              sx={{ color: "white", lineHeight: 1 }}
            >
              {likeCount}
            </Typography>
          </Box>
        )}

      {likeError && (
        <span className="sr-only" role="alert">
          Error: {likeError}
        </span>
      )}
    </IconButton>
  );
});

export default LikeButton;
